<div class="account-management-result">
  <div class="container-fluid">
    <div class="bg-white p-2 mt-2">
      <div class="row mt-3">
        <div class="col-md-9 col-sm-12 mb-1">
          <h1>Communication Log</h1>
        </div>
      </div>
      <form [formGroup]="form">
        <div class="row" *ngIf="lookupsData">
          <div class="col-2 mt-2" *ngIf="isSaleFeatureEnabled">
            <app-search-dropdown #salesDropdown [(items)]="lookupsData.allSales"
                                 [placeholder]="'All Sales'"
                                 [allOption]="'All Sales'"
                                 [label]="'Sale'"
                                 [limit]="10"
                                 [sortAsc]="false"
                                 (selectionChange)="handleSelectionSales($event)">
            </app-search-dropdown>
          </div>

          <div class="col-2 mt-2">

            <app-search-dropdown #recipientsDropdown [(items)]="lookupsData.allRecipients"
                                 [placeholder]="'All Recipients'"
                                 [allOption]="'All Recipients'"
                                 [label]="'Recipients'"
                                 [limit]="10"
                                 (selectionChange)="handleSelectionReceipients($event)">
            </app-search-dropdown>

          </div>
          <div class="col-auto mt-2">
            <div class="form-group">
              <label>
                Type
                <select class="form-control custom-form-select dropdown-arrow" formControlName="sentMailTypeId"
                        (change)="onPageSizeChange()">
                  <option value="" selected>All Types</option>
                  <option *ngFor="
                    let item of lookupsData.sentMailTypes" [value]="item.sentMailTypeId">
                    {{ item.sentMailTypeName }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="col-auto mt-2">
            <div class="form-group">
              <label>
                Channel
                <select class="form-control custom-form-select dropdown-arrow" formControlName="deliveryTypeId"
                        (change)="onPageSizeChange()">
                  <option value="" selected>All Channels</option>
                  <option *ngFor="
                    let item  of lookupsData.deliveryTypes" [value]="item.deliveryTypeId">
                    {{ item.deliveryTypeName }}
                  </option>
                </select>
              </label>
            </div>
          </div>

          <div class="col-auto mt-2">
            <div class="form-group">
              <label>
                Status
                <select class="form-control custom-form-select dropdown-arrow" formControlName="sendGridEventId"
                        (change)="onPageSizeChange()">
                  <option value="" selected>All Statuses</option>
                  <option *ngFor="
                    let item  of lookupsData.messageEvents" [value]="item.sendGridEventTypeId">
                    {{ item.eventType }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="col-auto d-flex align-items-center mt-1">
            <div class="form-group">
              <label>
                Search
              </label>
              <app-search-box #searchBox [debounce]="400" (searchChange)="applyFilter($event)" placeholder="Company, {{lotOrHipText}}, Subject...">
              </app-search-box>

            </div>
          </div>
          <div class="col-auto d-flex align-items-end">
            <button type="button"
                    class="btn mb-1 btn-secondary"
                    (click)="resetFilters()">
              <i class="fa fa-sync"></i>&nbsp; Reset
            </button>
          </div>
        </div>
      </form>

      
      <div class="communication-log">
        <div class="row mt-3">          
          <div class="table-scroll table-responsive data-grid sticky-header-table sticky-header-table-height-sm mt-3 p-0" #table>
            <table mat-table
                   [dataSource]="dataSource"
                   class="table table-hover"
                   matSort>

              <ng-container matColumnDef="sentDateUtc">
                <th mat-header-cell class="date-heading col-auto" *matHeaderCellDef mat-sort-header>
                  Date
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.sentDateUtc | date: dateFormat }} {{ element.sentDateUtc | date: "hh:mm a" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="company">
                <th mat-header-cell class="company-heading col-auto" *matHeaderCellDef mat-sort-header>
                  Company
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.company }}
                </td>
              </ng-container>

              <ng-container matColumnDef="to">
                <th mat-header-cell class="to-heading col-auto" *matHeaderCellDef mat-sort-header>
                  Recipent
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.to }}
                </td>
              </ng-container>

              <ng-container matColumnDef="mailTypeName">
                <th mat-header-cell class="type-heading col-auto" *matHeaderCellDef mat-sort-header>
                  Type
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.mailTypeName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="communicationType">
                <th mat-header-cell class="communication-type-heading col-auto" *matHeaderCellDef mat-sort-header>
                  Channel
                </th>
                <td mat-cell *matCellDef="let element" style="text-align: left">
                  <span *ngIf="element.deliveryTypeId === 1 || element.deliveryTypeId === 3" style="padding-right: 6px">
                    <img src="assets/images/email.png" class="default-img communication-log-icon" title="Email" />
                  </span>
                  <span *ngIf="element.deliveryTypeId === 2 || element.deliveryTypeId === 3" style="padding-right: 6px">
                    <img src="assets/images/sms.png" *ngIf="element.isSMS" class="default-img communication-log-icon" title="SMS" />
                  </span>
                  <span *ngIf="element.deliveryTypeId === 2 || element.deliveryTypeId === 3">
                    <img src="assets/images/whatsapp.png" *ngIf="element.isWhatsApp" class="default-img communication-log-icon" title="WhatsApp" />
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="subject">
                <th mat-header-cell class="sale-heading col-auto" *matHeaderCellDef mat-sort-header>
                  Subject
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.subject }}
                </td>
              </ng-container>
              <ng-container matColumnDef="saleName">
                <th mat-header-cell class="sale-heading col-auto" *matHeaderCellDef mat-sort-header>
                  Sale
                </th>

                <td mat-cell *matCellDef="let element">
                  <div class="border-0 ps-0">
                    <div class="title-wrap d-sm-flex align-items-center">
                      <div class="sale-title" style="position: relative">
                        <span class="text-default">
                          {{ element?.saleName }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="lot">
                <th mat-header-cell class="sale-heading col-1" *matHeaderCellDef mat-sort-header>
                  {{ lotOrHipText }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.lot }}
                </td>
              </ng-container>

              <!--<ng-container matColumnDef="whatsAppStatus">
          <th mat-header-cell class="status-heading col-1" *matHeaderCellDef mat-sort-header>
            WhatsApp Status
          </th>
          <td mat-cell *matCellDef="let element">

          </td>
        </ng-container>-->
              <ng-container matColumnDef="status">
                <th mat-header-cell class="status-heading col-1" *matHeaderCellDef mat-sort-header>
                  Status
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="comm-pair" *ngIf="element.deliveryTypeId === 1 || element.deliveryTypeId === 3">
                    <img src="assets/images/email.png" class="default-img communication-log-icon" title="Email" />
                    <span class="study-status-box {{getColorClass(element.status)}}">
                      {{ element.sendGridEvent }}
                    </span>
                  </div>
                  <div class="comm-pair" *ngIf="(element.deliveryTypeId === 2 || element.deliveryTypeId === 3) && element.isWhatsApp">
                    <img src="assets/images/whatsapp.png" class="default-img communication-log-icon" title="WhatsApp" />
                    <span class="whatsapp-status-box {{getWhatsAppColorClass(element)}}">
                      {{ element.whatsAppStatus }}
                    </span>
                  </div>
                  <div class="comm-pair" *ngIf="(element.deliveryTypeId === 2 || element.deliveryTypeId === 3) && element.isSMS">
                    <img src="assets/images/sms.png" class="default-img communication-log-icon" title="SMS" />
                    <span class="sms-status-box {{getSMSColorClass(element)}}">
                      {{ element.smsStatus }}
                    </span>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="open">
                <th mat-header-cell class="status-heading col-1" *matHeaderCellDef>
                  Action
                </th>
                <td mat-cell *matCellDef="let element">
                  <button type="button" title="Open Log Info" class="btn btn-outline-primary btn-sm"
                          (click)="openLogItem(element.sentMailLogId)">

                    <i class="fas fa-external-link-alt"></i>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="from">
                <th mat-header-cell class="from-heading col-auto" *matHeaderCellDef mat-sort-header>
                  From
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.from }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
              <tr mat-row *matRowDef="let row;
              columns: displayedColumns$.value;
              let vetUserIndex = index" class="border-start-0 border-end-0 pointer pt-2"></tr>
            </table>
          </div>
          <!--<div class="col-md-12 text-center" *ngIf="isLoader">
      Loading <i class="fa fa-spinner fa-spin"></i>
    </div>-->


          <div style="height:20px"></div>
          <div class="row text-center mb-3 px-3">
            <div *ngIf="totalRecords === 0" class="text-muted italic">
              No records found.
            </div>
          </div>
          <div class="row align-items-center mb-3 px-3" *ngIf="totalRecords > 0">
            <div class="col-xl-auto col-12 d-flex align-items-center justify-content-center justify-content-xl-start mb-3 mb-xl-0">
              <span class="text-nowrap">Show</span>
              <select class="form-select form-select-sm w-auto mx-2" [(ngModel)]="itemsPerPage" (change)="onPageSizeChange()">
                <option [value]="50">50</option>
                <option [value]="100">100</option>
                <option [value]="200">200</option>
                <option [value]="500">500</option>
              </select>
              <span class="text-nowrap">entries</span>
            </div>

            <div class="col-xl text-center text-muted small mb-3 mb-xl-0" >
              Showing <strong>{{ startRecord }}</strong> to <strong>{{ endRecord }}</strong>
              of <strong>{{ totalRecords }}</strong> records
              <span class="mx-2 text-secondary">|</span>
              Page <strong>{{ currentPage }}</strong> of <strong>{{ totalPages }}</strong>
            </div>            

            <div class="col-xl-auto col-12 d-flex justify-content-center">
              <nav aria-label="Table navigation" >
                <ul class="pagination pagination-sm mb-0">

                  <li class="page-item" [class.disabled]="currentPage <= 1">
                    <button class="btn borderradius btn-outline-primary" (click)="goToPage(1)" [disabled]="currentPage <= 1">First</button>
                  </li>

                  <li class="page-item" [class.disabled]="currentPage <= 1">
                    <button class="btn borderradius btn-outline-primary" (click)="goToPage(currentPage - 1)" [disabled]="currentPage <= 1">Previous</button>
                  </li>

                  <ng-container *ngFor="let page of getPaginationRange()">
                    <li class="page-item" [class.active]="page === currentPage" [class.disabled]="page === '...'">
                      <button *ngIf="page !== '...'" class="btn borderradius btn-outline-primary" (click)="goToPage(page)">
                        {{ page }}
                      </button>
                      <span *ngIf="page === '...'" class="btn borderradius btn-outline-primary">...</span>
                    </li>
                  </ng-container>

                  <li class="page-item" [class.disabled]="currentPage >= totalPages || totalPages === 0">
                    <button class="btn borderradius btn-outline-primary" (click)="goToPage(currentPage + 1)" [disabled]="currentPage >= totalPages || totalPages === 0">Next</button>
                  </li>

                  <li class="page-item" [class.disabled]="currentPage >= totalPages || totalPages === 0">
                    <button class="btn borderradius btn-outline-primary" (click)="goToPage(totalPages)" [disabled]="currentPage >= totalPages || totalPages === 0">Last</button>
                  </li>

                </ul>
              </nav>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
